import React, { useMemo } from 'react';
import styles from './TipResultDot.module.scss';
import SVG from 'react-inlinesvg';

/* Assets */
import tipResultDotWon from '../../../../../../assets/icons/tips/tip-result-dot-won.svg';
import tipResultDotLost from '../../../../../../assets/icons/tips/tip-result-dot-lost.svg';
import tipResultDotNotStarted from '../../../../../../assets/icons/tips/tip-result-dot-not-started.svg';
import tipResultDotNull from '../../../../../../assets/icons/tips/tip-result-dot-null.svg';
import tipResultDotCanceled from '../../../../../../assets/icons/tips/tip-result-dot-canceled.svg';

/* Interfaces */
import { TipResult } from '../../../../../../store/tips/reducer';

interface TipResultDotProps {
  result: TipResult;
}

export const TipResultDot: React.FC<TipResultDotProps> = ({ result }) => {
  const resultPath = useMemo(() => {
    switch (result) {
      case 'WON':
        return tipResultDotWon;
      case 'LOST':
        return tipResultDotLost;
      case 'NOT_STARTED':
        return tipResultDotNotStarted;
      case 'CANCELED':
        return tipResultDotCanceled;
      case 'VOID':
        return tipResultDotNull;
      default:
        return tipResultDotNotStarted;
    }
  }, [result]);

  return <SVG src={resultPath} className={styles.container} />;
};
